import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type FieldsetTableStylesType = {
  wrapper: SxProps
  actions: SxProps
  actionsInfo: SxProps
  requiredField: SxProps
}

export const fieldsetTableStyles: FieldsetTableStylesType = {
  wrapper: {
    borderRadius: '8px',
    border: `1px solid ${theme.colors.main200}`,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  },

  actions: {
    height: 50,
    backgroundColor: theme.colors.gray15,
    padding: theme.spacing(0, 1)
  },

  actionsInfo: {
    fontWeight: 700,
    fontSize: 16,
    color: theme.colors.gray600,
    padding: theme.spacing(0, 2)
  },

  requiredField: {
    display: 'block',
    color: theme.colors.red01,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    margin: '16px 0',

    '&:before': {
      position: 'relative',
      content: '"*"',
      fontFamily: theme.corporate.primaryFont,
      fontSize: '18px',
      color: theme.colors.red01
    }
  }
}
